
import angular from 'angular';

ParametersTagGroupAddController.$inject = ['$scope', 'tmhDynamicLocale', '$translate', '$state', '$stateParams', '$uibModalInstance', 'ParametersFactory', 'companyHasRoutingTag'];
export function ParametersTagGroupAddController($scope, tmhDynamicLocale, $translate, $state, $stateParams, $uibModalInstance, ParametersFactory, companyHasRoutingTag) {

  init();
  $scope.addTagGroup = addTagGroup;
  $scope.cancel = cancel;

  function addTagGroup() {

    let myResult = null;
    let data = {
      'name_fr': $scope.myTagGroup.nameFr,
      'name_en': $scope.myTagGroup.nameEn,
      'name_es': $scope.myTagGroup.nameEs,
      'name_nl': $scope.myTagGroup.nameNl,
      'is_routing': 0,
      'is_mandatory': ($scope.myTagGroup.isMandatory === false) ? 0 : 1
    };
    ParametersFactory.addTagGroup($stateParams.companyId, data).then(function(result, error) {
      if (angular.isUndefined(result.status)) {
        myResult = result;
      }
      $uibModalInstance.close(myResult);
    });

  }

  function cancel() {
    $uibModalInstance.dismiss('cancel');
  }

  function init() {
    $scope.myTagGroup = {
      'nameFr': '',
      'nameEn': '',
      'nameEs': '',
      'nameNl': '',
      'isRouting': false,
      'isMandatory': false
    };
    $scope.companyHasRoutingTag = companyHasRoutingTag;
  }

}
